export const SubscriptionStates = {
    PENDINGFULLFILMENT: 'PendingFulfillmentStart',
    SUBSCRIBED: 'Subscribed',
    SUSPENDED: 'Suspended',
    UNSUBSCRIBED: 'Unsubscribed'
};